import { AppDispatch } from "@/redux"
import { appActions } from "@/redux/slice/appSlice"
import { TransformationAPI } from "@/API/Transformation"
import { transformationActions } from "@/redux/slice/transformationSlice"

export const getAllTransformationTemplates = (
  token: string
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await TransformationAPI.getTemplates(token)
  if (resp.data) {
    dispatch(transformationActions.setTransformationTemplates(resp.data?.filter(t => t.isActive)))
  }
  dispatch(appActions.setLoading(false))
  return resp
}
